<template>
  <v-layout row justify-center align-center wrap class="mt-4 pt-2">
    <v-flex xs12 sm12 md4 lg6 xl6 class="mt-4 pt-2">
      <h2 class="mb-4 pl-4">Experience</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">JULY 2022 -</div>
                <div class="caption font-weight-bold green--text">PRESENT</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Software Engineer III</strong>
                <div class="caption mb-2">Walmart Inc.</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">SEP 2021 -</div>
                <div class="caption font-weight-bold green--text">JUN 2022</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Software Developer</strong>
                <div class="caption mb-2">Techline Pakistan | Programmers Force</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">NOV 2019 -</div>
                <div class="caption font-weight-bold green--text">OCT 2020</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Jr. Software Engineer</strong>
                <div class="caption mb-2">Programmers Force</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">OCT 2018 -</div>
                <div class="caption font-weight-bold green--text">JUN 2019</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Software Engineer</strong>
                <div class="caption mb-2">Pak Karubaar</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">JUN 2018 -</div>
                <div class="caption font-weight-bold green--text">OCT 2018</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Web Developer</strong>
                <div class="caption mb-2">TechHub Connect</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-flex xs12 sm12 md5 lg6 xl6 class="mt-4 pt-4">
      <h2 class="mb-4 pl-4 pt-2">Education</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">NOV 2020 -</div>
                <div class="caption font-weight-bold green--text">JUN 2023</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Masters in Computer Science</strong>
                <div class="caption mb-2">Maharishi International Univerity</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">SEP 2015 -</div>
                <div class="caption font-weight-bold green--text">JUL 2019</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Bachelors in Computer Science</strong>
                <div class="caption mb-2">COMSATS University Islamabad, Lahore Campus</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">AUG 2013 -</div>
                <div class="caption font-weight-bold green--text">APR 2015</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Intermediate (FSc Pre Engineering)</strong>
                <div class="caption mb-2">Punjab College of Science</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">SEP 2011 -</div>
                <div class="caption font-weight-bold green--text">MAY 2013</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Matriculation (Science)</strong>
                <div class="caption mb-2">H.Q School System</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Professional</span>

          <span class="green--text">Skills</span>
        </h2>
        <br>
        <strong>Java / Spring Boot</strong>
        <v-progress-linear v-model="buffer1" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Javascript / JQuery </strong>
        <v-progress-linear v-model="buffer3" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>PHP / Laravel (PHP Framework)</strong>
        <v-progress-linear v-model="buffer7" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>MySQL / PostgreSQL</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
      </v-flex>
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-5">
        <br>
        <strong>Python</strong>
        <v-progress-linear v-model="buffer2" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Node.JS / Express.JS / Angular.JS</strong>
        <v-progress-linear v-model="buffer8" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>TensorFlow</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Azure Cosmos DB / MongoDB / AWS DynamoDB</strong>
        <v-progress-linear v-model="buffer4" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
      </v-flex>
      <div class="mt-4 pt-2">
        <v-btn
          href="https://drive.google.com/file/d/1Z7L_qFJAw6XGkxS9ScSWtDTOTfVnkKDq/view?usp=drive_link"
          target="_blank"
          color="green"
          dark
          large
        >
          Download Detailed Resume
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  metaInfo: {
    title: "Resume",
    titleTemplate: "%s | Ahsan's Space",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Ahsan' Space" },
      { property: "og:site_name", content: "Ahsan' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://ahsanwaseem.tk" },
      {
        property: "og:image",
        content: "https://i.imgur.com/Dcz2PGx.jpg"
      },
      {
        property: "og:description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      }
    ]
  },
  data() {
    return {
      value: 0,
      buffer1: 0,
      buffer2: 0,
      buffer3: 0,
      buffer4: 0,
      buffer5: 0,
      buffer6: 0,
      buffer7: 0,
      buffer8: 0,
      bufferValue: 100,
      interval: 0
    };
  },
  mounted() {
    this.startBuffer();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    startBuffer() {
      this.interval = setInterval(() => {
        this.buffer1 = 90;
        this.buffer2 = 85;
        this.buffer3 = 80;
        this.buffer4 = 90;
        this.buffer5 = 85;
        this.buffer6 = 70;
        this.buffer7 = 85;
        this.buffer8 = 80;
      }, 800);
    }
  }
};
</script>
<style >
</style>

